import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { CombineRoute } from '@shared/constants/RelativePath';
import { SecurityState } from '@shared/store/reducers/security.reducer';
import { hasFeature } from '@shared/store/selectors/security.selector';
import { TransactionFeatures } from '../../transaction-features';
import {Router} from '@angular/router';

@Component({
    standalone: false,
    selector: 'lib-app-transaction-toolbar',
  templateUrl: './transaction-toolbar.component.html',
  styleUrls: ['./transaction-toolbar.component.scss'],
})
export class TransactionToolbarComponent implements OnInit {

  hasFeature$: Observable<any>;
  transactionFeatures = TransactionFeatures;

  constructor(private router: Router,
              private securityStore: Store<SecurityState>) { }

  ngOnInit() {
    this.hasFeature$ = this.securityStore.pipe(select(hasFeature));
  }

  navigateToTransactionsImport() {
    this.router.navigate(CombineRoute.TransactionsImportRoute);
  }
}
